import axios from 'axios';
import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Categories
export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

export const getCategory = async (id) => {
  const response = await api.get(`/categories/${id}`);
  return response.data;
};

// Products
export const getProduct = async (id) => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

export const getFeaturedProducts = async (limit = 12) => {
  const response = await api.get(`/featured?limit=${limit}`);
  return response.data;
};

// Search
export const searchProducts = async (query, limit = 20, offset = 0) => {
  const response = await api.get(`/search?q=${encodeURIComponent(query)}&limit=${limit}&offset=${offset}`);
  return response.data;
};

// Stats
export const getStats = async () => {
  const response = await axios.get(`${API_URL.replace('/api', '')}/api/stats`);
  return response.data;
};

export default api;
